/**
 * Displays the current maze level number in the HUD.
 * Plays a scale pulse and brief flash when the level changes.
 */

const TEXT_STYLE = {
  fontFamily: '"Courier New", Courier, monospace',
  fontSize: '14px',
  color: '#ffffff',
};

export default class LevelDisplay {
  /**
   * @param {Phaser.Scene} scene
   * @param {number} x
   * @param {number} y
   */
  constructor(scene, x, y) {
    this.scene = scene;
    this.text = scene.add.text(x, y, 'LEVEL: 1', TEXT_STYLE);
    this.text.setOrigin(0, 0.5);

    /** @private Track the previous level to detect changes. */
    this._lastLevel = 1;
  }

  /**
   * Update the displayed level.
   * If the level increased, play a pulse + flash animation.
   *
   * @param {number} level
   */
  setLevel(level) {
    this.text.setText(`LEVEL: ${level}`);

    if (level > this._lastLevel) {
      this._playLevelUpAnimation();
    }
    this._lastLevel = level;
  }

  /** Clean up. */
  destroy() {
    if (this.text) {
      if (this.scene) {
        this.scene.tweens.killTweensOf(this.text);
      }
      this.text.destroy();
      this.text = null;
    }
  }

  // ---------------------------------------------------------------
  // Private
  // ---------------------------------------------------------------

  /**
   * Play a scale pulse + brief bright flash when the level increases.
   * @private
   */
  _playLevelUpAnimation() {
    if (!this.text || !this.scene) return;

    // Kill any in-progress animation so they don't stack
    this.scene.tweens.killTweensOf(this.text);

    // Brief bright flash: turn text bright white then back to normal
    this.text.setStyle({ color: '#ffffff' });
    this.text.setScale(1);

    // Double pulse: big scale up → down → smaller scale up → down
    this.scene.tweens.add({
      targets: this.text,
      scaleX: 1.5,
      scaleY: 1.5,
      duration: 150,
      yoyo: true,
      ease: 'Quad.easeOut',
      onComplete: () => {
        if (!this.text || !this.scene) return;
        // Second (smaller) pulse
        this.scene.tweens.add({
          targets: this.text,
          scaleX: 1.25,
          scaleY: 1.25,
          duration: 120,
          yoyo: true,
          ease: 'Quad.easeOut',
          onComplete: () => {
            if (this.text) this.text.setScale(1);
          },
        });
      },
    });
  }
}
